import { cn } from "@/lib/utils";

interface ChatMessageProps {
  role: "user" | "assistant";
  message: string;
  createdAt: string;
}

export const Message = ({ role, message }: ChatMessageProps) => {
  const isUser = role === "user";
  
  return (
    <div className={cn(
      "flex flex-col gap-1 w-max max-w-[80%]",
      isUser ? "ml-auto" : "mr-auto"
    )}>
      {!isUser && (
        <span className="text-xs font-medium text-purple-400 ml-2">
          Claire
        </span>
      )}
      <p className={cn(
        "text-sm rounded-lg px-2 py-2 leading-normal whitespace-pre-wrap wrap-break-word border border-gray-200",
        isUser ? "bg-gray-50 text-gray-800 border-purple-200" : "bg-purple-50 text-purple-600 border-purple-200"
      )}>
        {message}
        </p>
    </div>
  );
}; 